import React from 'react';
import styles from './MetricCard.module.scss';
import { MetricCardConfig } from '../../../../Models/Widget';

export interface MetricCardProps extends MetricCardConfig {}

export const MetricCard = ({
  value
}: MetricCardProps): React.ReactElement<MetricCardProps> => {
  const strValue = `${Math.floor(value)}`;
  return (
    <div className={styles.metricCard}>
      <div className={styles.data}>
        <span className={styles.value}>{strValue}</span>
      </div>
    </div>
  );
};
